import {
  ACTION_LOAD_SOCIAL_NETWORKS__FAIL,
  ACTION_LOAD_SOCIAL_NETWORKS__REQUEST,
  ACTION_LOAD_SOCIAL_NETWORKS__SUCCESS,
} from '../../actionTypes';


export default (state = null, action) => {
  switch (action.type) {
    case ACTION_LOAD_SOCIAL_NETWORKS__SUCCESS:
    case ACTION_LOAD_SOCIAL_NETWORKS__REQUEST:
      return null;

    case ACTION_LOAD_SOCIAL_NETWORKS__FAIL:
      return action.payload.error;

    default:
      return state;
  }
};
